export default {
  styleOverrides: {
    root: {
      padding: '4px 4px 4px 16px !important',
      boxSizing: 'border-box'
    }
  }
}
